import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useStoreUTM = () => {
    const router = useRouter();

    useEffect(() => {
        const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = router.query;

        if (!localStorage.getItem('utm_source')) {
            if (utm_source) {
                localStorage.setItem('utm_source', utm_source as string);
            }
        }
        
        if (!localStorage.getItem('utm_medium')) {
            if (utm_medium) {
                localStorage.setItem('utm_medium', utm_medium as string);
            }
        }
        
        if (!localStorage.getItem('utm_campaign')) {
            if (utm_campaign) {
                localStorage.setItem('utm_campaign', utm_campaign as string);
            }
        }
        
        if (!localStorage.getItem('utm_term')) {
            if (utm_term) {
                localStorage.setItem('utm_term', utm_term as string);
            }
        }
        
        if (!localStorage.getItem('utm_content')) {
            if (utm_content) {
                localStorage.setItem('utm_content', utm_content as string);
            }
        }
        
    }, [router.query]);
};

export const useUTMStore = () => {
    const router = useRouter();
    const response = {};

    if(router && router.pathname) {
        response['landing_page'] = router.asPath;
    }
    if (typeof localStorage === 'undefined') {
        return response;
    } else {
        if(localStorage.getItem('utm_source')) {
            response['utm_source'] = localStorage.getItem('utm_source');
        }
        if(localStorage.getItem('utm_medium')) {
            response['utm_medium'] = localStorage.getItem('utm_medium');
        }
        if(localStorage.getItem('utm_campaign')) {
            response['utm_campaign'] = localStorage.getItem('utm_campaign');
        }
        if(localStorage.getItem('utm_term')) {
            response['utm_term'] = localStorage.getItem('utm_term');
        }
        if(localStorage.getItem('utm_content')) {
            response['utm_content'] = localStorage.getItem('utm_content');
        }
        return response;
    }
};
